// const Storage = Mach.requireModule('Storage');
let _SLDebugLogData: { type: string; content: string; itemId: string; }[] = [];
let _SLDebugLogAllData: { type: string; content: string; itemId: string; }[] = [];
let _SLDebugLogDataType = 'ALL';
let _SLDebugLogTypes = new Set<string>(['ALL']);
let _SLDebugLogIsShow = true;

const EventCenter = Mach.requireModule('EventCenter');

const getTime = () => {
  const date = new Date();
  return `[${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}]`;
};

// 缓存
const debugAppendLog = (type: string, log: string) => {
  if (log && _SLDebugLogIsShow) {
    const handleLog = `${getTime()}  ${log}`;
    if (_SLDebugLogDataType === 'ALL' || type === _SLDebugLogDataType) {
      _SLDebugLogData.push({ type, content: handleLog, itemId: 'debugid' });
    }
    _SLDebugLogAllData.push({ type, content: handleLog, itemId: 'debugid' });
    _SLDebugLogTypes.add(type);
  }
};

// 清除数据
const debugRemoveLog = () => {
  _SLDebugLogData = [];
  _SLDebugLogAllData = [];
  _SLDebugLogTypes = new Set<string>(['ALL']);
  _SLDebugLogDataType = 'ALL';
};

// 获取
const debugLogData = () => [..._SLDebugLogData];

//
const debugLogReportBusinessStep = (type: string, key: string, des: string = '') => {
  if (Mach.env.isDebug && _SLDebugLogIsShow && typeof type === 'string' && typeof key === 'string' && typeof des === 'string') {
    const step = `${key} ${des}`;
    debugAppendLog(type, step);
  }
};

const handleLog = async (type: string) => {
  if (!getAllLogTypes().includes(type)) {
    return;
  }
  _SLDebugLogDataType = type;
  const log = await new Promise<[]>((resolve) => {
    let filteredArray;
    if (type === 'ALL') {
      filteredArray = _SLDebugLogAllData;
    } else {
      filteredArray = _SLDebugLogAllData.filter((item) => item.type === type);
    }
    // const result = filteredArray.map(item => item.content).join('\n')
    resolve(filteredArray);
  });

  _SLDebugLogData = log;
};

const getAllLogTypes = () => Array.from(_SLDebugLogTypes);

const getSelectedType = () => _SLDebugLogDataType;

// 外部 获取不到ref
const debugLogEventCenter = (type: string, key: string, log: string) => {
  if (Mach.env.isDebug && _SLDebugLogIsShow) {
    EventCenter?.emit('sl_append_debug_log', { type, key, log });
  }
};

const setDebugLogIsShow = (isShow: boolean) => {
  _SLDebugLogIsShow = isShow;
};

const debugLogIsShow = () => _SLDebugLogIsShow;

export {
  debugLogData, debugRemoveLog, debugLogReportBusinessStep, handleLog, getAllLogTypes, getSelectedType, debugLogEventCenter, setDebugLogIsShow, debugLogIsShow
};
